import ReactComponent from '../app/ReactComponent'
import {Button, Col, Flex, Image, Row} from 'antd'
import {$t} from '../app'
import onYourOwnIcon from '../gfx/iceland-on-your-own-ico.png'
import {Link} from 'react-router-dom'
import GParallax from '../components/helpers/GParallax'

// IMAGES
import droneLandscapeImage from '../gfx/DJI_01652@small.jpg'
import {$language} from '../app/Languages'
import CardSanded from '../components/cards/CardSanded'
import Icon from '../components/helpers/Icon'

export default class GuideOverviewPage extends ReactComponent {
  state = {
    categories: []
  }

  componentDidMount() {

    this.scrollToTop()
    void this.getCategories()
    this.$app.$theme('dark')
  }

  async getCategories() {
    const active_lang = $language().$language()

    const data = await this.$app.$directus('categories', {
      fields: ['*', {translations: ['name', 'description', 'slug', 'button_text', 'help_text']}, {featured_image: ['*']}],
      filter: {
        status: {
          '_eq': 'published'
        }
      },
      deep: {
        translations: {
          _filter: {
            languages_code: {'_eq': active_lang}
          }
        }
      },
      meta: 'filter_count'
    })

    const categories = data.map(({translations, ...category}) => ({
      ...translations[0],
      ...category
    }))

    //console.log(categories)

    await this.updateState({categories: categories})
  }

  render() {
    return (
      <section className="">
        <div className="silencer medium"></div>
        <Flex align="center" justify="center">
          <div className="container wide ta-center">
            <h2 className="h1">
              <span className="_grey-primary-text"><$t _="online_guide"/></span>
            </h2>
            <h5 className="_grey-primary-text dib max-40em mb-4">
              <$t _="online_guide_description"/>
            </h5>

            <Row align="stretch" justify="center" gutter={[48, 48]} className="mt-3">
              {this.state.categories.map(category => (
                <>
                  <Col xs={24} sm={22} md={20} lg={16} xl={12}>
                    <CardSanded
                      title={category.name}
                      content={category.description}
                      image={`https://admin.trailsoficeandfire.com/assets/${category.featured_image.id}?quality=30`}
                      actions={
                        <>
                          <Button type="text" className="_font-text" size="small" icon={<Icon>send</Icon>}><$t _="contact_us" /></Button>
                          <Link to={`/online-guide/${category.slug}`}><Button type="primary" icon={<Icon>{category.button_icon || "visibility"}</Icon>}>{category.button_text || <$t _="show"/>}</Button></Link>
                        </>
                      }
                      help_text={category.help_text}

                    />

                    {/*<div className="card-blurred">
                      <div className="image-wrapper">
                        <Image src={category.featured_image && `https://admin.trailsoficeandfire.com/assets/${category.featured_image.id}?quality=30`} preview={false}/>
                      </div>
                      <div className="mb-3">

                        <h3 className="title">
                          {category.name}
                        </h3>

                        <p>{category.description}</p>

                        <br/>
                        <Link to={`/online-guide/${category.id}`}>
                          <Button type="primary">
                            <$t _="detail"/>
                          </Button>
                        </Link>
                      </div>
                    </div>*/}

                  </Col>
                </>
              ))}

            </Row>

          </div>
        </Flex>
        <div className="silencer medium"></div>
      </section>
    )
  }
}